/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { NamedTextValue } from './NamedTextValue';
import {
    NamedTextValueFromJSON,
    NamedTextValueFromJSONTyped,
    NamedTextValueToJSON,
} from './NamedTextValue';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';

/**
 * 
 * @export
 * @interface TextDataSetSetupDto
 */
export interface TextDataSetSetupDto {
    /**
     * 
     * @type {string}
     * @memberof TextDataSetSetupDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TextDataSetSetupDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TextDataSetSetupDto
     */
    dataTypeId: string;
    /**
     * 
     * @type {string}
     * @memberof TextDataSetSetupDto
     */
    iuid: string;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof TextDataSetSetupDto
     */
    origin: EntityOrigin;
    /**
     * 
     * @type {boolean}
     * @memberof TextDataSetSetupDto
     */
    isIdenticalOverAllSetupValues: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TextDataSetSetupDto
     */
    isIdenticalForSameDataType: boolean;
    /**
     * 
     * @type {Array<NamedTextValue>}
     * @memberof TextDataSetSetupDto
     */
    readonly values?: Array<NamedTextValue> | null;
    /**
     * 
     * @type {string}
     * @memberof TextDataSetSetupDto
     */
    $type?: TextDataSetSetupDtoTypeEnum;
}


/**
 * @export
 */
export const TextDataSetSetupDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoTextDataSetSetupDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.TextDataSetSetupDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TextDataSetSetupDtoTypeEnum = typeof TextDataSetSetupDtoTypeEnum[keyof typeof TextDataSetSetupDtoTypeEnum];



/**
 * Check if a given object implements the TextDataSetSetupDto interface.
 */
export function instanceOfTextDataSetSetupDto(value?: unknown): value is TextDataSetSetupDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TextDataSetSetupDtoTypeEnum)[0];
}

export function TextDataSetSetupDtoFromJSON(json: any): TextDataSetSetupDto {
    return TextDataSetSetupDtoFromJSONTyped(json, false);
}

export function TextDataSetSetupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TextDataSetSetupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'dataTypeId': json['dataTypeId'],
        'iuid': json['iuid'],
        'origin': EntityOriginFromJSON(json['origin']),
        'isIdenticalOverAllSetupValues': json['isIdenticalOverAllSetupValues'],
        'isIdenticalForSameDataType': json['isIdenticalForSameDataType'],
        'values': json['values'] == null ? undefined : ((json['values'] as Array<any>).map(NamedTextValueFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TextDataSetSetupDtoToJSON(value?: Omit<TextDataSetSetupDto, 'values'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'name': value['name'],
        'dataTypeId': value['dataTypeId'],
        'iuid': value['iuid'],
        'origin': EntityOriginToJSON(value['origin']),
        'isIdenticalOverAllSetupValues': value['isIdenticalOverAllSetupValues'],
        'isIdenticalForSameDataType': value['isIdenticalForSameDataType'],
        '$type': value['$type'],
    });
}

